import React, { useState, useRef } from "react";
import "../css/Control.css";
import "../css/SophisticationLevel.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

function SophisticationLevel({ value, onChange }) {
  const [tooltipStyle, setTooltipStyle] = useState({ display: "none" });
  const iconRef = useRef(null);

  const showTooltip = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setTooltipStyle({
        display: "block",
        top: `${rect.top + window.scrollY - 10}px`,
        left: `${rect.left + window.scrollX + rect.width + 20}px`,
      });
    }
  };

  const hideTooltip = () => {
    setTooltipStyle({ display: "none" });
  };

  const handleSliderChange = (e) => {
    onChange(parseInt(e.target.value));
  };

  const getDescriptionText = () => {
    if (value <= 2) return "Basic";
    if (value <= 4) return "Intermediate";
    if (value <= 6) return "Advanced";
    if (value <= 8) return "Expert";
    return "Master";
  };

  const getDescriptionColor = () => {
    if (value <= 2) return "#10b981";
    if (value <= 4) return "#3b82f6";
    if (value <= 6) return "#f59e0b";
    if (value <= 8) return "#ef4444";
    return "#7c3aed";
  };

  return (
    <div className="control-group">
      <div className="control-label-container">
        <label className="control-label">Sophistication Level</label>
        <FontAwesomeIcon
          ref={iconRef}
          icon={faCircleInfo}
          onMouseEnter={showTooltip}
          onMouseLeave={hideTooltip}
          className="control-icon"
        />
        <div className="control-tooltip" style={tooltipStyle}>
          How complex and realistic the phishing attempts should be. Higher
          values create more convincing simulations.
        </div>
      </div>

      <div className="control-content">
        <div className="range-container">
          <input
            type="range"
            min="1"
            max="10"
            value={value}
            onChange={handleSliderChange}
            className="range-input sophistication-slider"
          />
          <div
            className="range-value"
            style={{
              backgroundColor: `${getDescriptionColor()}20`,
              color: getDescriptionColor(),
            }}
          >
            {value}/10
          </div>
        </div>{" "}
        <div className="sophistication-info">
          <div
            className="sophistication-description"
            style={{ color: getDescriptionColor() }}
          >
            {getDescriptionText()}
          </div>
          <div className="range-labels">
            <span>Basic</span>
            <span>Advanced</span>
            <span>Master</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SophisticationLevel;
